import { Dialog, useDialog } from 'components';
import { FC, useEffect, useState } from 'react';
import { getLocations, resendEdiForTransaction } from 'services';
import { EdiCustomerLocation, Location, Transaction } from 'types';


export const ResendTransactionEdiDialog: FC<{
  close: () => void;
  ediCustomerLocations: EdiCustomerLocation[];
  transaction: Transaction;
}> = ({ close, ediCustomerLocations, transaction }) => {
  const [_locations, setLocations] = useState<Location[]>([]);
  const { openDialog, ref } = useDialog();
  useEffect(() => {
    openDialog();
    getLocations().then(setLocations);
  }, [setLocations]);

  const [recipientIds, setRecipientIds] = useState<number[]>([]);
  console.log(ediCustomerLocations);
  return (
    <Dialog closeDialog={close} ref={ref} >
      <h3 className='page-header text-primary-dark header-border-bottom'>EDI Recipients</h3>
      <div>
        <div className={`grid-3 p-2 align-items-center`}>
          <span className='d-flex justify-content-center margin-bottom-16px'>Mapping ID</span>
          <span className='d-flex justify-content-center margin-bottom-16px'>Partnership ID</span>
          <span className='d-flex justify-content-center margin-bottom-16px'>Resend</span>
          {
            ediCustomerLocations.map((row, idx) => (
              <>
                <div className={`grid-row-${idx+2} d-flex justify-content-center `} >{row.mappingId}</div>
                <div className={`grid-row-${idx+2} d-flex justify-content-center `} >{row.partnershipId}</div>
                <input
                  key={idx + '7'}
                  className={`grid-column-3 grid-row-${idx+2} padding-bottom-0px`}
                  checked={recipientIds.includes(row.id ?? 0)}
                  type='checkbox'
                  onChange={(e) => {
                    console.log(recipientIds);
                    const index = recipientIds.findIndex((n) => n === (row.id ?? 0));
                    console.log(index);
                    console.log(row.id);
                    index < 0
                      ? setRecipientIds([ ...recipientIds, row.id ?? 0 ])
                      : setRecipientIds([
                        ...recipientIds.slice(0, index),
                        ...recipientIds.slice(index + 1)
                      ])
                  }}
                />
              </>
            ))
          }
        </div>
        <div className='d-flex flex-row justify-content-end g-2 margin-top-16px' >
          <button className='btn-outline'
            onClick={close}
          >
            Cancel
          </button>
          <button className='btn-primary'
            onClick={e => {
              recipientIds.forEach(id => resendEdiForTransaction(transaction.id, id))
              close();
            }}
          >
            Send
          </button>
        </div>
      </div>
    </Dialog>
  );
};